import { writable } from "svelte/store";

export const showGlobalTick = writable(Boolean);
export const infoPopup = writable(false);
export const instructions = writable(true);
export const beeSwarmData = writable([{P15:0, label:""}, {P15:0, label:""}, {P15:0, label:""}, {P15:0, label:""}]);
export const loadedData = writable([]);
export const selectedCity = writable("");
export const selectedCityName = writable("");
export const selectedCountry = writable("");

// export const showSearchBar = writable(Boolean);